import { render } from "./RoleComponent.vue?vue&type=template&id=dfd11d3c"
import script from "./RoleComponent.vue?vue&type=script&lang=js"
export * from "./RoleComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__